export default __webpack_public_path__ + "static/media/icons8-remove.a250858e.svg";